module.exports = __webpack_public_path__ + "assets/b3c97915dbfa7439942fc70f4f0ee320.png";